import { memo } from 'react';

function JobCardSkeleton() {
  return (
    <div className="p-4 mx-4 mb-3 w-[95%] card-base animate-pulse border border-gray-100">
      {/* Job Title and Status */}
      <div className="flex-between">
        <div className="flex-between gap-2">
          <div className="w-32 h-5 bg-gray-200 rounded"></div> {/* Job Title */}
          <div className="w-16 h-5 bg-gray-200 rounded"></div>
          {/* Status Badge */}
        </div>

        <div className="flex gap-2">
          <div className="w-10 sm:w-20 h-8 bg-gray-200 rounded"></div>{' '}
          {/* Edit Button */}
          <div className="w-10 sm:w-28 h-8 bg-gray-200 rounded"></div>{' '}
          {/* View Applicants */}
        </div>
      </div>

      {/* Location and Posted Time */}
      <div className="flex flex-col sm:flex-row gap-1.5 sm:gap-4 mt-2">
        <div className="w-24 h-4 bg-gray-200 rounded"></div> {/* Location */}
        <div className="w-24 h-4 bg-gray-200 rounded"></div> {/* Posted Time */}
      </div>

      {/* Experience */}
      <div className="mt-1 flex gap-1">
        <div className="w-32 h-4 bg-gray-200 rounded"></div>
      </div>

      {/* Job Description */}
      <div className="w-full h-10 bg-gray-200 rounded mt-1"></div>

      {/* View Full JD */}
      <div className="w-24 h-4 bg-gray-200 rounded mt-2"></div>

      {/* Skills */}
      <div className="mt-3">
        <div className="w-32 h-4 bg-gray-200 rounded mb-2"></div>{' '}
        {/* Skill Criteria */}
        <div className="flex flex-wrap gap-2">
          <div className="w-16 h-6 bg-gray-200 rounded"></div>
          <div className="w-16 h-6 bg-gray-200 rounded"></div>
          <div className="w-16 h-6 bg-gray-200 rounded"></div>
        </div>
      </div>
    </div>
  );
}

export default memo(JobCardSkeleton);
